// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! mixins */.title[data-v-0fe67404]{margin:1.6rem 0;color:var(--text-primary)}@media (min-width:1024px){.title[data-v-0fe67404]{margin:2.4rem 0}}.last-modified[data-v-0fe67404]{margin-bottom:2.4rem;color:var(--border-primary)}@media (min-width:1024px){.last-modified[data-v-0fe67404]{margin-bottom:4.8rem}}section.section.section-news[data-v-0fe67404]{overflow:unset}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
